"use strict";

define('components/filter_bar/table/bulk_data_room_invite',['components/ajax'], function(ajax) {
    var dataRoomInviteComponent = {
        initWithContext: function(context) {
            var dataroomButtons = context.buttonbarNode.find('.selection-data-room-invite button');
            dataroomButtons.click(function() {
                // This can be either the invite or the revoke button.
                var button = $(this);

                // This ajax request's response will trigger the small-modal containing the
                // invite-to-dataroom form
                var formData = new FormData();
                var prospectIds = context.tableFilterBarData.tableInstance.getSelectedObjectIds()
                formData.append('prospect_ids', JSON.stringify(prospectIds));
                var url = $(this).data('url');
                ajax(url, {
                    formData: formData,
                    remote: url
                });
            });
        }
    };

    return dataRoomInviteComponent;
});

